import { AppShellData } from './index';
import { Action } from 'redux';
import { saveAppShellData } from './utils';
import { UPDATE_APP_SHELL_DATA, UpdateAppShellDataAction } from './action-creators';

export default <TAppShell extends AppShellData>(state: TAppShell, action: Action): TAppShell => {
  switch (action.type) {
    case UPDATE_APP_SHELL_DATA: {
      const appShellData = (action as UpdateAppShellDataAction<TAppShell>).appShellData;
      // Not really nice to have side effects in a reducer but the action can be dispatched from multiple places
      saveAppShellData(appShellData);
      return appShellData;
    }

    default:
      return state;
  }
};
